import { FormValue } from 'informed';

import { Branch, Country, District, State } from '@nw/shared/config';

import { allowedCharactersInComboBoxRegexPattern } from '../../constants/RegexPatternConstants';

export const getStateDetailsFromStateName = (
  stateName: State | string,
  states: State[]
) => {
  if (typeof stateName === 'string') {
    return states.find((state) => state.state_name === stateName);
  }
  return states.find((state) => state.state_id === stateName?.state_id);
};

export const getStateDetailsFromStateId = (
  stateId: string,
  states: State[]
) => states.find((state) => state.state_id === stateId);

export const getStateIdFromStateName = (
  stateName: string,
  states: State[]
) => states.find((state) => state.state_name === stateName)?.state_id;

export const getStateNameFromStateId = (
  stateId: string,
  states: State[]
) => states.find((state) => state.state_id === stateId)?.state_name;

export const getCountryDetailsFromCountryName = (
  countryName: string,
  countries: Country[]
) => countries.find((country) => country.country_name === countryName);

export const getCountryDetailsFromCountryId = (
  countryId: string,
  countries: Country[]
) => countries.find((country) => country.country_id === countryId);

export const getCountryNameFromCountryId = (
  countryId: string,
  countries: Country[]
) =>
  countries.find((country) => country.country_id === countryId)?.country_name;

export const getCountryIdFromCountryName = (
  countryName: string,
  countries: Country[]
) =>
  countries.find((country) => country.country_name === countryName)?.country_id;

export const getDistrictDetailsFromDistrictName = (
  districtName: string,
  districts: District[]
) => districts.find((district) => district.district_name === districtName);

export const getDistrictDetailsFromDistrictId = (
  districtId: string,
  districts: District[]
) => districts.find((district) => district.district_id === districtId);

export const getDistrictNameFromDistrictId = (
  districtId: string,
  districts: District[]
) =>
  districts.find((district) => district.district_id === districtId)
    ?.district_name;

export const getDistrictIdFromDistrictName = (
  districtName: string,
  districts: District[]
) =>
  districts.find((district) => district.district_name === districtName)
    ?.district_id;

export const getFilteredStates = (filterText: string, states: State[]) => {
  const filteredStates: State[] = [];

  states.forEach((state: State) => {
    if (state.state_name.toUpperCase().includes(filterText.toUpperCase())) {
      filteredStates.push(state);
    }
  });

  return filteredStates;
};

export const getFilteredCountries = (
  filterText: string,
  countries: Country[]
) => {
  const filteredCountries: Country[] = [];

  countries.forEach((country: Country) => {
    if (country.country_name.toUpperCase().includes(filterText.toUpperCase())) {
      filteredCountries.push(country);
    }
  });

  return filteredCountries;
};

export const getFilteredDistricts = (
  filterText: string,
  districts: District[]
) => {
  const filteredDistricts: District[] = [];

  districts.forEach((district: District) => {
    if (
      district.district_name.toUpperCase().includes(filterText.toUpperCase())
    ) {
      filteredDistricts.push(district);
    }
  });

  return filteredDistricts;
};

export const getBranchDetailsFromBranchId = (
  branchId: string,
  branches: Branch[]
) => branches.find((branch) => branch.branch_id === branchId);

export const getBranchIdFromBranchName = (
  branchName: FormValue<string>,
  branches: Branch[]
) => branches.find((branch) => branch.branch_name === branchName)?.branch_id;

export const getBranchNameFromBranchId = (
  branchId: string,
  branches: Branch[]
) => branches.find((branch) => branch.branch_id === branchId)?.branch_name;

export const getComboBoxAllowedCharacters = (text: string): string => {
  return text
    .replace(allowedCharactersInComboBoxRegexPattern, '') //remove not allowed characters
    .replace(/\s+/g, ' '); //replace multiple spaces
};
